<template>
  <div class="row align-items-center justify-center data__details-nav">
    <div class="col-auto">
      <zbm-btn-icon @click="onPrevClick(dateRange.startDate)" icon="fa-light fa-circle-chevron-left" size="24px"
        :buttonHeight="$zb.enums.ButtonHeightEnum.lg" :disabled="disablePrev" color="white" class="text-dark-teal" />
    </div>
    <div class="col-auto range px-20">{{ startDateFormatted }} - {{ endDateFormatted }}</div>
    <div class="col-auto">
      <zbm-btn-icon @click="onNextClick(dateRange.endDate)" icon="fa-light fa-circle-chevron-right" size="24px"
        :buttonHeight="$zb.enums.ButtonHeightEnum.lg" :disabled="disabledNextComp" color="white"
        class="text-dark-teal" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { localizedStatDate } from 'src/utils/dateUtil';
import { custom_moment } from '@/plugins/moment-cultured';
import { useLocalizationStore } from '@/store';

const localizationStore = useLocalizationStore();

const props = defineProps({
  disablePrev: Boolean,
  disableNext: Boolean
});

const dateRange = defineModel('dateRange', {
  default: () => ({
    startDate: '',
    endDate: '',
  })
})

const init = () => {
  const today = custom_moment().weekday(),
    startDate = custom_moment().subtract(today, 'days').format('YYYY-MM-DD'),
    endDate = custom_moment(startDate).add(6, 'days').format('YYYY-MM-DD');

  dateRange.value = {
    startDate,
    endDate,
  };
}

const startDateFormatted = computed(() => {
  return localizedStatDate(dateRange.value.startDate, localizationStore.locale);
});

const endDateFormatted = computed(() => {
  return localizedStatDate(dateRange.value.endDate, localizationStore.locale);
});

const disabledNextComp = computed(() => {
  return props.disableNext || custom_moment().isBetween(dateRange.value.startDate, dateRange.value.endDate);
});

function onPrevClick(start: string) {
  const tempEnd = custom_moment(start).subtract(1, 'days'),
    tempStart = custom_moment(tempEnd).subtract(6, 'days');

  dateRange.value = {
    startDate: custom_moment(tempStart).format('YYYY-MM-DD'),
    endDate: custom_moment(tempEnd).format('YYYY-MM-DD'),
  };
}
function onNextClick(end: string) {
  const tempStart = custom_moment(end).add(1, 'days'),
    tempEnd = custom_moment(tempStart).add(6, 'days');

  dateRange.value = {
    startDate: custom_moment(tempStart).format('YYYY-MM-DD'),
    endDate: custom_moment(tempEnd).format('YYYY-MM-DD'),
  };
}

defineExpose({
  init
})
</script>
